
























































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import OrderGiziFormDialog from "@/components/gizi/OrderGiziFormDialog.vue";
import TanggalGizi from "@/components/gizi/TanggalGizi.vue";
import OrderGiziSvc from "@/services/OrderGizi";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { SHIFT_ORDER_GIZI, shiftSekarang } from "@/constants/gizi";
import { isRanap } from "@/utils/unit";
import { OrderGizi } from "@/types/orderGizi";

@Component({
  components: { OrderGiziFormDialog, TanggalGizi }
})
export default class OrderGiziPemesananPage extends Vue {
  tanggal = shiftSekarang().tanggal;
  pesanan: OrderGizi[] = [];
  memuat = false;
  memuatDetail: number | null = null;
  dialogForm = false;
  orderDiubah: OrderGizi | null = null;
  dialogHapus = false;
  orderDihapus: OrderGizi | null = null;
  menghapus = false;
  tokenMuat = 0;

  readonly headers = [
    { text: "Shift", value: "shift", width: "190" },
    { text: "Jumlah", value: "jumlah_pasien", width: "110" },
    { text: "Petugas Pemesan", value: "pemesan_nama" },
    { text: "Waktu Pesan", value: "created_at", width: "170" },
    { text: "Catatan", value: "catatan" },
    { text: "", value: "aksi", align: "end", width: "150", sortable: false }
  ];

  get unitId(): string {
    return userModule.loginUnitId || "";
  }

  get unitNama(): string {
    return userModule.loginUnitNama || "";
  }

  get bangsalValid(): boolean {
    return isRanap(this.unitId);
  }

  get ringkasShift() {
    return SHIFT_ORDER_GIZI.map(s => ({
      value: s.value,
      text: s.text,
      jumlah: this.pesanan
        .filter(p => p.shift === s.value)
        .reduce((total, p) => total + Number(p.jumlah_pasien || 0), 0)
    }));
  }

  mounted() {
    this.muat();
  }

  @Watch("tanggal")
  onGantiTanggal() {
    this.muat();
  }

  async muat() {
    if (!this.bangsalValid || !this.tanggal) {
      this.pesanan = [];
      return;
    }

    const token = ++this.tokenMuat;
    this.memuat = true;
    try {
      const data = await OrderGiziSvc.daftarPesanan(this.unitId, this.tanggal);
      if (token === this.tokenMuat) {
        this.pesanan = data;
      }
    } catch {
      return;
    } finally {
      if (token === this.tokenMuat) {
        this.memuat = false;
      }
    }
  }

  buatPesanan() {
    this.orderDiubah = null;
    this.dialogForm = true;
  }

  async ubahPesanan(item: OrderGizi) {
    this.memuatDetail = item.id;
    try {
      this.orderDiubah = await OrderGiziSvc.detail(item.id);
      this.dialogForm = true;
    } catch {
      return;
    } finally {
      this.memuatDetail = null;
    }
  }

  setelahSimpan(order: OrderGizi) {
    if (order && order.tanggal !== this.tanggal) {
      this.tanggal = order.tanggal;
      return;
    }
    this.muat();
  }

  cetak(item: OrderGizi) {
    OrderGiziSvc.cetakPesanan(item.id);
  }

  konfirmasiHapus(item: OrderGizi) {
    this.orderDihapus = item;
    this.dialogHapus = true;
  }

  async hapus() {
    if (!this.orderDihapus) return;

    this.menghapus = true;
    try {
      await OrderGiziSvc.hapus(this.orderDihapus.id);
      appModule.NoticeDelay("Pesanan makanan dihapus");
      this.dialogHapus = false;
      this.orderDihapus = null;
      this.muat();
    } catch {
      return;
    } finally {
      this.menghapus = false;
    }
  }

  jamShift(shift: string): string {
    const opsi = SHIFT_ORDER_GIZI.find(s => s.value === shift);
    return opsi ? opsi.jam : "";
  }

  formatTanggal(tanggal: string | null): string {
    if (!tanggal || tanggal.length < 10) return "-";
    const [y, m, d] = tanggal.slice(0, 10).split("-");
    return `${d}/${m}/${y}`;
  }

  formatWaktu(waktu: string | null): string {
    if (!waktu || waktu.length < 16) return "-";
    return `${this.formatTanggal(waktu)} ${waktu.slice(11, 16)}`;
  }
}
